import { post } from "./api";
import { IloginDto, ISignUpDto } from "../interfaces/dto/auth.dto";
import { APIUrl } from "../config/api-url.config";
import {
  ISignUpOtp,
  ILoginPayload,
  IForgotPasswordPayload,
  IUpdatePasswordPayload,
} from "../interfaces/auth";

export const login = (payload: ILoginPayload) =>
  post<ILoginPayload, IloginDto>(APIUrl.login, payload);

export const forgotPassword = (payload: IForgotPasswordPayload) =>
  post<IForgotPasswordPayload, ISignUpDto>(APIUrl.forgotPassword, payload);

export const signUp = (payload: ILoginPayload) =>
  post<ILoginPayload, ISignUpDto>(APIUrl.signup, payload);

export const signupOtp = (payload: ISignUpOtp) =>
  post<ISignUpOtp, IloginDto>(APIUrl.verifyOTP, payload);

export const resendOtp = (payload: { userId: string }) =>
  post<{ userId: string }, ISignUpDto>(APIUrl.resendOTP, payload);

export const updatePassword = (payload: IUpdatePasswordPayload) =>
  post<IUpdatePasswordPayload, ISignUpDto>(APIUrl.updatePassword, payload);
